import React from 'react';

import {
  ErrorText,
  ErrorHeader,
  ActionButton,
  ErrorContainer,
  ErrorHeaderSmall,
  ErrorMessageWrapper,
} from './response-error.styled';

const ArchivedFormError = () => {
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <p id="exclaim">Oops!</p>
        <ErrorHeader>We are sorry, this form is temporarily unavailable</ErrorHeader>
        <ErrorText>
          <p>
            If you are the form owner, this is because your account has been inactive for over 60 days. Kindly login to
            the application and re-save this form on your builder.
          </p>
        </ErrorText>
        <ErrorHeaderSmall>Want to create your own forms?</ErrorHeaderSmall>
        <ErrorText>
          <p>You can explore all Formplus features for free.</p>
        </ErrorText>
        <ActionButton href="/?utm_source=forms&utm_medium=archivedforms&utm_campaign=archived%20forms%20CTA">
          Get Started
        </ActionButton>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default ArchivedFormError;
